import { Http } from "@/util";

export function getProblemList(param) {
  return Http.post("/admin/problem/list", param);
}

// 获取需要客服处理的订单问题列表
export function getKfNeedFocusProblemList() {
  return Http.get("/admin/order-problem/list", { _hideLoading: true });
}

// 客服回复
export function kfReply(param) {
  return Http.post("/admin/order-problem/kf/reply", param);
}

// 获取订单问题详情
export function getOrderProblem(problemId) {
  return Http.get("/admin/order-problem/get/problem", { problemId, _hideLoading: true });
}

// 更新客服处理状态
export function updateKfHandlingStatus(problemId) {
  return Http.get("/admin/order-problem/update/kf-handling", { problemId });
}

// 更新客服信息已读状态
export function updateKfInfoReadStatus(problemId) {
  return Http.get("/admin/order-problem/update/info-read-status", { problemId });
}
